<template>
    <div class="location-container">
      <img src="../../assets/location.svg" class="preview-img mr-2" />
      <p>{{ locationName }}</p>
    </div>
</template>


<script>
export default {
  name: "Location",
  props: {
    locationName: {
      type: String,
    },
  },
  computed: {},
};
</script>


<style scoped>
.location-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 75vw;
  width: fit-content;
  padding: 0.4rem;
  color: rgb(255, 255, 255);
  border-radius: 1rem;
  background-color: #413f43;
  z-index: 100;
}
.location-container p {
  font-size: 0.8rem;
  padding: 0;
  margin: 0 0 0 0.3rem;
}
@media only screen and (max-width: 700px) {
  .location-container {
    max-width: 100vw;
    width: fit-content;
  }
  .location-container p {
    font-size: 0.76rem;
  }
}
@supports (-webkit-touch-callout: none) and (not (translate: none)) {
  .header{
    width: 96%;
  }
  .location-container {
    max-width: 100vw;
    width: fit-content;
  }
}
</style>